import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../../actionTypes';

const initialState = false;

const isLoading = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.FETCH_FIELDS]: isLoading,
  [actionTypes.FETCH_FIELDS_SUCCESS]: isEnding,
  [actionTypes.FETCH_FIELDS_FAILURE]: isEnding,
});
